var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('ve-liquidfill',{attrs:{"height":"100%","extend":_vm.chartExtends,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }